import LoginForm from 'components/loginForm'
import { useAuth } from 'hooks'
import { Helmet } from 'react-helmet'
import { Navigate } from 'react-router-dom'
import { PAGE_DASHBOARD } from 'utils/constants'

const Login = () => {
  const { isAuthenticated } = useAuth()

  // commented - we are not using store order page anymore
  // if (
  //   isAuthenticated &&
  //   user?.pageAccess.some(({ page }) => page === PAGE_STORE_ORDERS.id)
  // ) {
  //   return <Navigate replace to={PAGE_STORE_ORDERS.path} />
  // }

  if (isAuthenticated) {
    return <Navigate replace to={PAGE_DASHBOARD.path} />
  }

  return (
    <>
      <Helmet>
        <title>ORMS Login</title>
      </Helmet>
      <div className="flex h-full w-full items-center justify-center">
        <LoginForm />
      </div>
    </>
  )
}

export default Login
